//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'HeaderContainer',

    props: ['title', 'sub', 'image', 'css', 'opacity', 'blur', 'overlay', 'move'],

    data(){ return {
        imageSrc: '',
        background: this.image ? 'url(' + this.image + ')' : '',
        coreStyles: {
            // backgroundImage : this.image ? 'url(' + this.image + ')' : '',
            minHeight: "800px",
        },
    }},

    computed: {
        finalStyle(){ return this.css ? Object.assign({}, this.coreStyles, this.css) : this.coreStyles },
        overlayStyle(){ return { opacity: this.opacity ? this.opacity : '0.3' } },
        backgroundStyle(){ return { filter: this.blur ? 'blur(' + this.blur + 'px)' : '', transform: 'scale(1.1)' } },
    },

    mounted(){

    }
}
